<template>
    <q-btn-dropdown split class="btn-dropdown" color="secondary" :label="label" >
        <q-list>
            <q-item clickable  v-for="(button, index) in buttons" :key="index" v-close-popup @click="() => $emit('action-button', button)">
                <q-item-section avatar>
                    <q-avatar size="md" :icon="button.nmIcon" color="secondary" text-color="white" />
                </q-item-section>
                <q-item-section>
                    <q-item-label class="btn-title"> {{ button.label }}</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({

  props: {
    rowsSelected: {
      type: Number
    },
    label: {
      type: String,
      required: true
    },
    buttons: {
      type: Array,
      required: true
    }
  }

})
class BIllingOrderDropdownButton extends Vue {

}
export default BIllingOrderDropdownButton
</script>
<style scoped>
.btn-title {
    font-weight: 500;
}

.btn-dropdown {
    margin: 0;
}
</style>
